/**
 * TriggerTypeBadge — Reusable badge for automation trigger type
 */

import { Clock, Zap, Globe, Play } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

const TRIGGER_CONFIG: Record<string, { label: string; icon: LucideIcon; color: string }> = {
  scheduled: { label: 'Scheduled', icon: Clock, color: 'bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/30' },
  event: { label: 'Event', icon: Zap, color: 'bg-amber-500/10 text-amber-800 dark:text-amber-300 border-amber-500/30' },
  webhook: { label: 'Webhook', icon: Globe, color: 'bg-sky-500/10 text-sky-700 dark:text-sky-300 border-sky-500/20' },
  manual: { label: 'Manual', icon: Play, color: 'bg-cyan-500/10 text-cyan-700 dark:text-cyan-300 border-cyan-500/20' },
  workflow: { label: 'Workflow', icon: Zap, color: 'bg-violet-500/10 text-violet-700 dark:text-violet-300 border-violet-500/30' },
  playbook: { label: 'Playbook', icon: Play, color: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20' },
};

export function TriggerTypeBadge({ type, className }: { type: string; className?: string }) {
  const config = TRIGGER_CONFIG[type] ?? { label: type, icon: Zap, color: '' };
  const Icon = config.icon;
  return (
    <Badge variant="outline" className={cn('text-[9px] gap-1', config.color, className)}>
      <Icon className="h-2.5 w-2.5" />
      {config.label}
    </Badge>
  );
}
